import { DocPage, Section, SpecTable, DoDont } from "../../components/DocChrome";

export function PermissionsPage() {
    return (
        <DocPage
            title="Role & Permission UX"
            description="Visual consistency ≠ identical UX. Roles change availability; components stay the same."
        >
            <Section title="Patterns">
                <SpecTable
                    rows={[
                        ["Hide", "Action not relevant to role — omit from UI"],
                        ["Disable + reason", "Temporarily unavailable (plan gate, closed shift)"],
                        ["Permission denied empty", "ErrorState explaining missing capability"],
                        ["Read-only", "Detail visible; edit controls absent"],
                        ["Contextual actions", "Row menus filtered by ability"],
                    ]}
                />
            </Section>
            <DoDont
                doItems={[
                    "Reuse Button/Table even when actions differ by role",
                    "Explain plan gates clearly",
                ]}
                dontItems={[
                    "Fork a special 'OwnerButton' visual",
                    "Silently fail forbidden actions",
                ]}
            />
        </DocPage>
    );
}
